import axios from "axios";

/**
 *
 * @status no delete
 * @class CompanyService
 */
class CompanyService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    /**
 * @author Edgar Escobedo
 * @description Get companys from a clientId
 * @date 20-07-2020
 * @param {String} token
 * @returns {Object}
 * @memberof CompanyService
 */
    async getCompanys(token) {
        let response = await axios.get(
            `${this.apiUrl}/client-company`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response;
    }

    /**
* @author Junaid Khan
* @description Creates the business profile with information in data
* @date 24-06-2024
* @param {Object} data
* @param {String} token
* @returns {Object}
* @memberof CompanyService
*/
    async createBusinessProfile(data, token) {
        data = {
            ...data,
            numEmployeesOptionId: data.numEmployees.id,
            numUsersAppOptionId: data.numUsers.id,
            economicSectorId: data.economicSector.id
        }

        if (data.regime?.id) data.taxRegimeId = data.taxRegime.id
        if (data.marketNiche?.id) data.marketNicheId = data.marketNiche.id

        delete data.numEmployees;
        delete data.numUsers;
        delete data.taxRegime;
        delete data.economicSector;
        delete data.marketNiche;

        let response = await axios.post(
            `${this.apiUrl}/business-profile-passthrough`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data.statusCode !== 200) {
            throw new Error(response.data.message)
        }
        return response.data.data
    }

    /**
     * @author Brayan Salas
     * @description Method to update user profile
     * @param {*} data
     * @param {*} token
     * @param {*} origin
     * @return {*} 
     * @memberof CompanyService
     */
    async updateUserProfile(data, token, origin) {
        let url = '/profile-user-passthrough'
        if (origin) {
            data.origin = origin
            url = '/profile-user-passthrough-onboarding-user'
        }

        let response = await axios.put(
            `${this.apiUrl}${url}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data.statusCode !== 200) {
            throw new Error(response.data.message)
        }
        return response.data.data
    }
}

export { CompanyService as default };